import { render, staticRenderFns } from "./AllCategory.vue?vue&type=template&id=4af991d0&scoped=true"
import script from "./AllCategory.vue?vue&type=script&lang=js"
export * from "./AllCategory.vue?vue&type=script&lang=js"
import style0 from "./AllCategory.vue?vue&type=style&index=0&id=4af991d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af991d0",
  null
  
)

export default component.exports